import {Component, EventEmitter, Injector, Input, OnInit, Output, forwardRef, inject} from '@angular/core';
import {ControlValueAccessor, FormControl, FormControlName, FormsModule, NG_VALUE_ACCESSOR, NgControl, NgModel} from '@angular/forms';
import {NgbDate, NgbDateStruct, NgbDatepickerModule} from '@ng-bootstrap/ng-bootstrap';

import * as dayjs from 'dayjs';

const DATE_EDIT_CONTROL_VALUE_ACCESSOR = {
  multi: true,
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => TmwDateEditComponent),
};

const noop = (): void => {};

@Component({
  selector: 'tmw-date-edit',
  standalone: true,
  template: `<div class="input-group">
    <input
      [class]="readOnly ? 'form-control form-control-sm readonly-field' : 'form-control form-control-sm'"
      placeholder="dd/mm/yyyy"
      name="dp"
      [minDate]="minDate"
      [maxDate]="maxDate"
      (dateSelect)="update($event)"
      [(ngModel)]="_value"
      ngbDatepicker
      #d="ngbDatepicker"
      container="body"
      (change)="update(_value)"
      [disabled]="_disabled"
      [readOnly]="readOnly"
    />
    <button
      class="btn btn-outline-secondary bi bi-calendar3"
      (click)="openDatepicker(d)"
      type="button"
      [disabled]="_disabled"
    ></button>
  </div>`,
  imports: [NgbDatepickerModule, FormsModule],
  styleUrl: './date-edit.component.scss',
  providers: [DATE_EDIT_CONTROL_VALUE_ACCESSOR],
})
export class TmwDateEditComponent implements ControlValueAccessor {
  _value?: any;
  _disabled: boolean = false;
  // @Input() required: boolean = false;
  @Input() readOnly: boolean = false;
  _minDate: any;
  @Input() set minDate(val: any) {
    this._minDate = this.fromModel(val);
  }

  get minDate() {
    return this._minDate;
  }
  _maxDate: any;
  @Input() set maxDate(val: any) {
    this._maxDate = this.fromModel(val);
  }

  get maxDate() {
    return this._maxDate;
  }

  private onTouched: () => void = noop;
  private onChange: (_: any) => void = noop;
  @Output() private modified = new EventEmitter<any>();

  openDatepicker(datepicker: any) {
    if (!this._disabled && !this.readOnly) {
      datepicker.toggle();
    }
  }

  update($event: NgbDate | undefined) {
    this._value = $event;
    let val = this.toModel(this._value);
    if (val && ((this.minDate && dayjs(val).isBefore(this.toModel(this.minDate))) || (this.maxDate && dayjs(val).isAfter(this.toModel(this.maxDate))))) {
      this._value = val = undefined;
    }
    this.onTouched();
    this.onChange(val);
    this.onChange(val);
    this.modified.next(val);
  }

  fromModel(raw: any): NgbDateStruct | undefined {
    let result = undefined;
    if (raw) {
      let day = dayjs(raw);
      result = { day: day.date(), month: day.month() + 1, year: day.year() };
    }
    return result;
  }

  toModel(val) {
    let result = null;
    if (val) {
      if (val.length) {
        let parts = val.split('/');
        if (parts.length == 3) {
          result = dayjs(new Date(+parts[2], +parts[1] - 1, +parts[0], 11)).toISOString();
        } else {
          result = undefined;
        }
      } else {
        result = dayjs(new Date(val.year, val.month - 1, val.day, 11)).toISOString();
      }
    } else {
      result = undefined;
    }
    return result;
  }

  writeValue(day: any): void {
    this._value = this.fromModel(day);
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this._disabled = isDisabled;
  }
}
